var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeQuestionSizesWeightoutlined = function SvgTypeQuestionSizesWeightoutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M10.938 14.063a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.874 0M10 5.624c-1.723 0-3.125 1.262-3.125 2.813v.312a.625.625 0 0 0 1.25 0v-.312c0-.86.841-1.563 1.875-1.563s1.875.703 1.875 1.563C11.875 9.297 11.034 10 10 10a.625.625 0 0 0-.625.625v.625a.625.625 0 1 0 1.25 0v-.056c1.425-.262 2.5-1.399 2.5-2.757 0-1.55-1.402-2.812-3.125-2.812M18.125 10A8.125 8.125 0 1 1 10 1.875 8.133 8.133 0 0 1 18.125 10m-1.25 0A6.875 6.875 0 1 0 10 16.875 6.883 6.883 0 0 0 16.875 10"
  })));
};
export default SvgTypeQuestionSizesWeightoutlined;